import React from "react";
import { cn } from "@/lib/utils";

// Plain bordered container (animated neon border treatment removed).
export const AnimatedBorderCard = ({ children, className, innerClassName, ...props }) => {
    return (
        <div className={cn("rounded-lg border border-white/12", className)} {...props}>
            <div className={cn("rounded-lg bg-surface-panel", innerClassName)}>
                {children}
            </div>
        </div>
    );
};
